import { ActionType, ActionTypes, State } from './types';

const initialState = {
  isLoading: false,
  error: '',
  data: [],
};

const legacyOrdersReducers = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.FETCH_ORDERS_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: [...action.payload],
      };
    case ActionTypes.FETCH_ORDERS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case ActionTypes.CLEAR_ORDERS:
      return {
        ...state,
        data: [],
      };
    case ActionTypes.REMOVE_SELECTED_ORDER:
      return {
        ...state,
        data: state.data?.filter((order) => order.id !== action.payload),
      };
    default:
      return state;
  }
};

export default legacyOrdersReducers;
